<template>
  <div class="container-fluid">
    <div class="row d-flex justify-content-start">
      <div class="col-12 px-0">
        <SectionTitle
          class="responsive-section-title"
          has-line
          content="Información de Servicio a Solicitar"
        />
      </div>
    </div>

    <div id="dropdown-wrapper" class="row">
      <div class="col-12 px-0 px-md-3 col-md-4">
        <ValidationProvider v-slot="{ errors }" rules="required">
          <custom-drop-down
            v-model="selectedType"
            :options="referralTypes"
            label="Tipo de Servicio:"
            fieldkey="id"
            fieldname="name"
            placeholder="Seleccione"
            class="height-fixed"
            :error="errors[0]"
            :clearable="false"
            :custom-error-msg="resources['25023']"
            :disabled="readOnly"
          />
        </ValidationProvider>
      </div>
    </div>

    <div class="row">
      <div class="col-12 pl-0 px-md-3">
        <ValidationProvider rules="required">
          <EquipmentAdd
            v-for="section in equipmentSections"
            v-show="showSection(section) || isForTrainningWithData(section)"
            ref="equipmentSection"
            :key="section.inputLabel"
            :table-id="section.tableId"
            :input-label="section.inputLabel"
            :input-placeholder="section.inputPlaceholder"
            :prepend-icon="section.inputIcon"
            :prepend-icon-type="section.inputIconType"
            :prepend-icon-color="section.inputIconColor"
            :btn-border-color="section.btnBorderColor"
            :add-equipment="section.addEquipment"
            :added-equipment="section.equipments"
            :read-only="readOnly"
            @addEquipment="addEquipment"
            @removeEquipment="removeEquipment"
          />
        </ValidationProvider>
        <Error
          v-if="!value.hasEquipment"
          variant="no-border"
          :message="resources['25022']"
        />
      </div>
    </div>
  </div>
</template>

<script>
import SectionTitle from 'SectionTitle';
import CustomDropDown from 'custom-drop-down';
import EquipmentAdd from '@/views/pei/requestTechAssistanceServices/components/EquipmentAdd';
import { getReferralTypes } from '@/modules/request-tech-service-assistance/api';
import referralTypes from '@/utils/constants/pei/referral/referralTypes';
import alert from 'utils/mixins/alert.mixin.js';
import resourcesService from '@/services/resources.js';
import Error from 'custom-error';

const ForTrainningTableId = 'forTrainning';

export default {
  name: 'ServicesRequestInformation',
  mixins: [alert],
  components: {
    SectionTitle,
    CustomDropDown,
    EquipmentAdd,
    Error,
  },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    selectedType: function(newValue, oldValue) {
      this.onReferralTypeChange(newValue, oldValue);
    },
    value: function() {
      this.setEquipments();
    },
  },
  data() {
    return {
      resources: [],
      selectedType: null,
      referralTypes: [],
      equipmentSections: [
        {
          tableId: 'toCustomize',
          tableType: referralTypes.solicitudServicioRelacionadoEquipo,
          inputLabel: 'Personalizar o adaptar el siguiente equipo:',
          inputPlaceholder: 'Escriba nombre del equipo',
          inputIcon: 'fas fa-plus',
          inputIconType: 'success',
          inputIconColor: 'green',
          btnBorderColor: 'green',
        },
        {
          tableId: 'toRepair',
          tableType: referralTypes.solicitudServicioRelacionadoEquipo,
          inputLabel: 'Reparar o reemplazar el siguiente equipo por avería:',
          inputPlaceholder: 'Escriba nombre del equipo',
          inputIcon: 'fas fa-plus',
          inputIconType: 'success',
          inputIconColor: 'green',
          btnBorderColor: 'green',
        },
        {
          tableId: 'toReplaceForTheft',
          tableType: referralTypes.solicitudServicioRelacionadoEquipo,
          inputLabel:
            'Reemplazar el siguiente equipo de asistencia por hurto  (Incluir copia de la querella de la policía):',
          inputPlaceholder: 'Escriba nombre del equipo',
          inputIcon: 'fas fa-plus',
          inputIconType: 'success',
          inputIconColor: 'green',
          btnBorderColor: 'green',
        },
        {
          tableId: 'toReplaceForLost',
          tableType: referralTypes.solicitudServicioRelacionadoEquipo,
          inputLabel:
            'Reemplazar el siguiente equipo de asistencia por pérdida:',
          inputPlaceholder: 'Escriba nombre del equipo',
          inputIcon: 'fas fa-plus',
          inputIconType: 'success',
          inputIconColor: 'green',
          btnBorderColor: 'green',
        },
        {
          tableId: 'forTechAssistance',
          tableType: referralTypes.solicitudServicioAsistenciaTecnica,
          inputLabel:
            'Asesoría o asistencia técnica para la implantación al currículo:',
          inputPlaceholder: 'Escriba nombre del equipo',
          inputIcon: 'fas fa-plus',
          inputIconType: 'success',
          inputIconColor: 'green',
          btnBorderColor: 'green',
        },
        {
          tableId: ForTrainningTableId,
          tableType: referralTypes.solicitudServicioRelacionadoEquipo,
          inputLabel:
            'Capacitación o adiestramiento del(de los) siguiente(s) equipos(s):',
          inputPlaceholder: 'Escriba nombre del equipo',
          inputIcon: 'fas fa-plus',
          inputIconType: 'success',
          inputIconColor: 'green',
          btnBorderColor: 'green',
        },
      ],
    };
  },
  computed: {
    isForTrainningWithData() {
      return section => section.tableId == ForTrainningTableId && this.value.equipmentsForTrainning.length;
    },
  },
  methods: {
    async loadResources() {
      this.resources = await resourcesService.LoadValidationMessages([
        '25023',
        '25022',
      ]);
    },
    async getReferralTypes() {
      await getReferralTypes().then(({ data }) => {
        this.referralTypes = data;
      });
    },
    async onReferralTypeChange(newSelection, oldSelection) {
      if (
        oldSelection != null &&
        this.value.referralType == oldSelection &&
        this.hasEquipment()
      ) {
        const answer = await this.ShowCancelModal(
          'Confirmación',
          'Al cambiar la opción seleccionada se eliminarán los datos documentados en la sección de servicios a solicitar. ¿Está seguro que desea descartar la información antes de continuar?'
        );

        if (!answer) {
          this.value.referralType = oldSelection;
          this.selectedType = oldSelection;
          return;
        } else {
          this.clearEquipmentsLists();
        }
      }

      this.value.referralType = newSelection;
    },
    showSection(section) {
      return (
        this.value.referralType &&
        section.tableType == this.value.referralType?.id
      );
    },
    clearEquipmentsLists() {
      this.value.equipmentsToCustomize = [];
      this.value.equipmentsToRepair = [];
      this.value.equipmentsToReplaceForTheft = [];
      this.value.equipmentsToReplaceForLost = [];
      this.value.equipmentsForTechAssistance = [];
      this.value.equipmentsForTrainning = [];

      this.$refs.equipmentSection.forEach((x) => {
        x.clear();
      });
    },
    addEquipment(item, tableId) {
      switch (tableId) {
        case 'toCustomize':
          this.value.equipmentsToCustomize.push(item);
          break;
        case 'toRepair':
          this.value.equipmentsToRepair.push(item);
          break;
        case 'toReplaceForTheft':
          this.value.equipmentsToReplaceForTheft.push(item);
          break;
        case 'toReplaceForLost':
          this.value.equipmentsToReplaceForLost.push(item);
          break;
        case 'forTechAssistance':
          this.value.equipmentsForTechAssistance.push(item);
          break;
        case 'forTrainning':
          this.value.equipmentsForTrainning.push(item);
          break;
        default:
          break;
      }
    },
    removeEquipment(equipmentIndex, tableId) {
      switch (tableId) {
        case 'toCustomize':
          this.value.equipmentsToCustomize.splice(equipmentIndex, 1);
          break;
        case 'toRepair':
          this.value.equipmentsToRepair.splice(equipmentIndex, 1);
          break;
        case 'toReplaceForTheft':
          this.value.equipmentsToReplaceForTheft.splice(equipmentIndex, 1);
          break;
        case 'toReplaceForLost':
          this.value.equipmentsToReplaceForLost.splice(equipmentIndex, 1);
          break;
        case 'forTechAssistance':
          this.value.equipmentsForTechAssistance.splice(equipmentIndex, 1);
          break;
        case 'forTrainning':
          this.value.equipmentsForTrainning.splice(equipmentIndex, 1);
          break;
        default:
          break;
      }
    },
    hasEquipment() {
      return (
        this.value.equipmentsToCustomize.some((x) => x) ||
        this.value.equipmentsToRepair.some((x) => x) ||
        this.value.equipmentsToRepair.some((x) => x) ||
        this.value.equipmentsToReplaceForTheft.some((x) => x) ||
        this.value.equipmentsForTechAssistance.some((x) => x) ||
        this.value.equipmentsForTrainning.some((x) => x)
      );
    },
    setEquipments() {
      if (this.readOnly) {
        this.selectedType = this.value.referralType;

        this.$refs.equipmentSection.forEach((x) => {
          switch (x.tableId) {
            case 'toCustomize':
              x.equipments = this.value.equipmentsToCustomize;
              break;
            case 'toRepair':
              x.equipments = this.value.equipmentsToRepair;
              break;
            case 'toReplaceForTheft':
              x.equipments = this.value.equipmentsToReplaceForTheft;
              break;
            case 'toReplaceForLost':
              x.equipments = this.value.equipmentsToReplaceForLost;
              break;
            case 'forTechAssistance':
              x.equipments = this.value.equipmentsForTechAssistance;
              break;
            case 'forTrainning':
              x.equipments = this.value.equipmentsForTrainning;
              break;
            default:
              break;
          }
        });
      }
    },
  },
  async mounted() {
    await this.getReferralTypes();
    await this.loadResources();
  },
};
</script>

<style scoped>
::v-deep label.data-name {
  color: #11291b !important;
}

.box-container {
  background-color: #f7f7f7;
  padding: 15px;
  border-radius: 5px;
}

@media only screen and (max-width: 500px) {
  #dropdown-wrapper >>> .vs__selected {
    font: 0.7rem Lato;
  }

  #dropdown-wrapper >>> .vs__dropdown-menu {
    font: 0.7rem Lato;
  }

  .responsive-section-title >>> .tag-badge-title-info {
    font-size: 0.8rem;
  }
}
</style>
